import { render } from "./MainBody.vue?vue&type=template&id=3f04a8d5&scoped=true"
import script from "./MainBody.vue?vue&type=script&lang=js"
export * from "./MainBody.vue?vue&type=script&lang=js"

import "./MainBody.vue?vue&type=style&index=0&id=3f04a8d5&lang=less&scoped=true"

import exportComponent from "E:\\MyProject\\crash-webfrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f04a8d5"]])

export default __exports__